import { H1 } from '@liveauctioneers/hammer-ui-core/text';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { NationalLogisticServicePolicy } from '@/components/PartnerPolicies/components/NationalLogisticService/NationalLogisticServicePolicy';
import { PackengersPolicy } from '@/components/PartnerPolicies/components/Packengers/PackengersPolicy';
import { ShippingPartnerIds } from '@/enums/shippingProviders';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getNotFoundUrl } from '@/utils/urls';

type ShippingPolicyRouteParams = {
    partnerId: string;
};

const VALID_PARTNER_IDS = new Set([
    ShippingPartnerIds.ThePackengers,
    ShippingPartnerIds.NationalLogisticServices,
    ShippingPartnerIds.ChairishAuctions,
]);

const ShippingPolicyPage = () => {
    const formatMessage = useAppFormatMessage();
    const navigate = useNavigate();
    const { partnerId } = useParams<ShippingPolicyRouteParams>();
    const numericPartnerId = Number(partnerId);
    const isValidPartner = VALID_PARTNER_IDS.has(numericPartnerId);

    useEffect(() => {
        if (!isValidPartner) {
            navigate(getNotFoundUrl());
        }
    }, [isValidPartner, navigate]);

    if (!isValidPartner) {
        return null;
    }

    let policyContent: JSX.Element;
    let partnerName: string;

    switch (numericPartnerId) {
        case ShippingPartnerIds.ThePackengers:
            policyContent = <PackengersPolicy />;
            partnerName = 'ThePackengers';
            break;
        case ShippingPartnerIds.NationalLogisticServices:
            policyContent = <NationalLogisticServicePolicy />;
            partnerName = 'National Logistic Services';
            break;
        case ShippingPartnerIds.ChairishAuctions:
            // waiting on legal to verify content for chairish policy - using NLS text for now
            policyContent = <NationalLogisticServicePolicy />;
            partnerName = 'Chairish Auctions';
            break;
        default:
            return null;
    }
    return (
        <section className="relative mx-auto mb-0 mt-lg flex max-w-[1240px] flex-col px-md pb-xl">
            <H1 className="mb-sm">
                {formatMessage(['partners', 'pageTitle'], {
                    values: { partnerName },
                })}
            </H1>
            <div className="[&_strong]:inline">{policyContent}</div>
        </section>
    );
};

export default ShippingPolicyPage;
